module.exports = __webpack_public_path__ + "static/media/descubre.1f6cd361.png";